import React from 'react';
import { Select, FetchOptionsResult } from '../Select';
import { suggestCities } from '../../api/dadata';

interface CitySelectProps {
  value: string;
  onChange: (value: string) => void;
  name?: string;
  icon?: React.ReactNode;
  placeholder?: string;
}

const fetchCityOptions = async ({ search }: { page: number; search: string }): Promise<FetchOptionsResult> => {
  const cities = await suggestCities(search);
  return {
    items: cities.map(c => ({ value: c, label: c })),
    hasMore: false,
  };
};

const CitySelect: React.FC<CitySelectProps> = ({
  value,
  onChange,
  name,
  icon,
  placeholder = 'Введите город...',
}) => (
  <Select
    value={value}
    onChange={onChange}
    name={name}
    fetchOptions={fetchCityOptions}
    icon={icon}
    placeholder={placeholder}
    searchPlaceholder="Введите город..."
  />
);

export { CitySelect };
